// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__gCs03","welcome__img_block":"Welcome_welcome__img_block__2qaz-","welcome__title":"Welcome_welcome__title__17uhW"};